// LandingPage.js
import React, { useEffect } from "react";
import { onAuthStateChanged } from 'firebase/auth';
import "./LandingPage.css";
import Footer from "./Footer";
import { useNavigate } from 'react-router-dom';

function LandingPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // redirect if already authenticated via Firebase
    import('./firebaseConfig').then(({ auth }) => {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          navigate('/chat');
        }
      });
    });
  }, [navigate]);

  return (    
    <div className="landing-container">
      
      {/* Background shapes */}
      <div className="bg-shape bg-shape1"></div>
      <div className="bg-shape bg-shape2"></div>
      <div className="bg-shape bg-shape3"></div>

      {/* Top Navigation Bar */}
      <div className="topbar">
        <a href="https://ozia-ai.netlify.app">
          <img src="/logo.png" alt="Ozia AI Logo" className="landing-logo" />
        </a>
        
      </div>
{/* Floating Action Dock */}
<div className="floating-dock">
  {/* Login Button */}
  <a href="/login" className="fab-btn" title="Sign In">
    <i className="fas fa-sign-in-alt"></i>
  </a>

  {/* Register Button - Using user-plus for a "Join" feel */}
  <a href="/signup" className="fab-btn" title="Create Account">
    <i className="fas fa-user-plus"></i>
  </a>

  {/* More Options Dropdown */}
  <div className="fab-dropdown-container">
    <div className="fab-btn" title="Resources">
      <i className="fas fa-th-large"></i> {/* Modern grid icon instead of dots */}
    </div>
    
<div className="fab-dropdown-menu">
  {/* Profile & Identity */}
  <a href="/profile" className="fab-dropdown-item">
    <i className="fas fa-user-circle"></i> My Profile
  </a>

  {/* AI & Plan Management */}
  <a href="/settings/plan" className="fab-dropdown-item">
    <i className="fas fa-bolt"></i> Upgrade Plan
  </a>

  {/* App Settings */}
  <a href="/settings" className="fab-dropdown-item">
    <i className="fas fa-cog"></i> Settings
  </a>

  {/* Social / About Section */}
  <a href="/about" className="fab-dropdown-item">
    <i className="fas fa-fingerprint"></i> About OZIA
  </a>

  {/* Support & Contact */}
  <a href="/contact" className="fab-dropdown-item">
    <i className="fas fa-paper-plane"></i> Contact Us
  </a>

  {/* Help & Resources */}
  <a href="/help" className="fab-dropdown-item">
    <i className="fas fa-life-ring"></i> Help Center
  </a>
</div>
  </div>
</div>      {/* Header Section */}
      <header className="landing-header section-container">
        <h1>Welcome to OZIA AI</h1>
        <p>
          OZIA AI is your personal, intelligent AI assistant — smarter, faster, and always learning. 
          Designed to help you solve problems, answer questions, and boost productivity like never before.
        </p>
        <a href="/signup" className="cta-button">Get Started</a>
      </header>

      {/* Expanded Description Section */}
      <section className="ozia-description-section">
        <div className="section-container">
          <div className="ozia-description-header">
            <h2>About OZIA AI</h2>
            <p style={{ color: '#aaa', fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto' }}>
              OZIA AI is a cutting-edge artificial intelligence platform that acts as your personal assistant. 
              It can understand complex queries, reason like a human, and provide insightful responses in real-time. 
            </p>
          </div>

          <div className="ozia-description-grid">
            <div className="description-block">
              <h3>Who Created OZIA AI?</h3>
              <p>
                Built by a team of passionate developers and AI enthusiasts, dedicated to making advanced artificial intelligence accessible to everyone. 
                Every feature is designed with speed, security, and usability in mind.
              </p>
            </div>
            <div className="description-block">
              <h3>What is OZIA Hub?</h3>
              <p>
                OZIA Hub is the central platform where all OZIA AI services and tools are available. 
                It's your gateway to explore AI capabilities, manage your interactions, and stay updated.
              </p>
            </div>
            <div className="description-block">
              <h3>Where to Find OZIA Hub?</h3>
              <p>
                You can access OZIA Hub online at <a href="https://ozia.netlify.app/" className="ozia-link">OZIAHUB<i className="fas fa-external-link-alt"></i></a>. 
                All features, resources, and AI tools are available directly from the Hub with a seamless experience across devices.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features section */}
      <section className="features-section">
        <div className="section-container features-grid">
          {[
            { title: 'Chat Smarter', desc: 'Interact naturally and get intelligent responses in real-time.' },
            { title: 'Secure & Private', desc: 'Your data stays safe. OZIA AI respects your privacy and protects your information.' },
            { title: 'Always Learning', desc: 'OZIA AI continuously improves its algorithms to assist you better every day.' }
          ].map((feature, index) => (
            <div key={index} className="feature-card">
              <h2>{feature.title}</h2>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="section-container">
          <h2>Choose Your Plan</h2>
          <div className="pricing-cards">
            
            <div className="pricing-card">
              <div>
                <h3>FREE</h3>
                <p>Essential AI features to get you started on your journey.</p>
              </div>
              <a href="/signup" className="cta-button outline">Get Started</a>
            </div>

            <div className="pricing-card better">
              <div>
                <h3>BETTER</h3>
                <p>Enhanced AI capabilities, faster response times, and priority support.</p>
              </div>
              <a href="/signup" className="cta-button betterbtn">Upgrade Now</a>
            </div>


            <div className="pricing-card premium">
              <div>
                <h3>ADVANCED</h3>
                <p>The ultimate AI toolset with unlimited context and custom integrations.</p>
              </div>
              <a href="/signup" className="cta-button">Upgrade Now</a>
            </div>

          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section className="roadmap-section">
        <div className="section-container">
          <h2>Our Journey</h2>
          <div className="roadmap-tree">
            <div className="roadmap-item">
              <div className="roadmap-dot"></div>
              <div className="roadmap-content">
                <h3>Idea Conception</h3>
                <p>The initial concept of OZIA AI was born, imagining a smarter, more contextual personal assistant.</p>
              </div>
            </div>

            <div className="roadmap-item">
              <div className="roadmap-dot"></div>
              <div className="roadmap-content">
                <h3>Prototype Development</h3>
                <p>Built our first AI prototype and rigorously tested core functionalities with early users.</p>
              </div>
            </div>

            <div className="roadmap-item">
              <div className="roadmap-dot"></div>
              <div className="roadmap-content">
                <h3>Feature Expansion</h3>
                <p>Added advanced chat intelligence, enterprise-grade privacy features, and constant learning loops.</p>
              </div>
            </div>

            <div className="roadmap-item">
              <div className="roadmap-dot"></div>
              <div className="roadmap-content">
                <h3>Launch & Growth</h3>
                <p>Official public launch, a rapidly growing user base, and continuous UI/UX improvements.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <div className="footer-wrapper">
        <Footer />
      </div>

    </div>
  );
}

export default LandingPage;